import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const styles = (theme) => {
  const {
    spacing: { unit },
    custom: {
      palette: { colorSupportPowder },
    },
  } = theme;

  return {
    menuItem: {
      backgroundColor: colorSupportPowder,
    },
    addIcon: {
      marginRight: unit,
    },
  };
};

class Option extends PureComponent {
  handleClick = (event) => {
    const { onSelect, option } = this.props;

    onSelect(option, event);
  };

  render() {
    const { children, classes, isSelected, isFocused, onFocus, option } = this.props;
    const showAddIcon = option.id === 'create-new' || option.value === 'create-new';

    return (
      <MenuItem
        component="div"
        onClick={this.handleClick}
        onFocus={onFocus}
        selected={isSelected}
        className={isFocused && !isSelected ? classes.menuItem : ''}
        // this will unfocus the previous focused option
        onMouseMove={() => onFocus(undefined)}
      >
        {showAddIcon && <AddCircleIcon className={classes.addIcon} />}
        {children}
      </MenuItem>
    );
  }
}

Option.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool.isRequired,
  onFocus: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
};

export default withStyles(styles)(Option);
